var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component",class:{ _disabled: _vm.disabled, '_with-packshot': _vm.packshot }},[_c('div',{staticClass:"time-points",style:({
      width: _vm.packshot ? 'calc(100% - 16px)' : 'calc(100% - 16px - 65px)',
    })},_vm._l((Array(
        Math.ceil(_vm.duration / _vm.speed + (_vm.packshot ? _vm.packshotDuration : 0))
      )),function(point,i){return _c('div',{key:i,staticClass:"time-points__point",style:({
        left:
          (i / (_vm.duration / _vm.speed + (_vm.packshot ? _vm.packshotDuration : 0))) * 100 +
          '%',
      })},[_vm._v(" "+_vm._s(i % 5 === 0 ? i : " ")+" "),_c('div',{staticClass:"time-points__point__line"})])}),0),_c('div',{ref:"gap",staticClass:"slide-container",class:{ '_with-packshot': _vm.packshot },style:({
      width: _vm.packshot
        ? 'calc(' + _vm.getVideoPercentDuration() + '% - 16px)'
        : 'calc(100% - 16px - 65px)',
    })},[_c('div',{staticClass:"slide-container__background"},[_c('div',{ref:"snapshots",staticClass:"slide-container__background__snapshots"},[_c('ResizeObserver',{on:{"notify":_vm.onResize}}),(!_vm.thumbs)?_c('canvas',{attrs:{"id":"canvas","width":"288","height":"50"}}):_vm._e(),_vm._l((_vm.thumbs),function(thumbSource){return _c('img',{key:thumbSource,style:({
            width: 'calc(100% / ' + _vm.thumbs.length + ')',
            position: 'relative',
            objectFit: 'cover',
          }),attrs:{"src":_vm.$baseURL + thumbSource}})})],2)]),_c('div',{staticClass:"slide-container__range-gap",class:{
        _active: _vm.isDragLeft || _vm.isDragRight,
        _changed: _vm.relativeWidth !== 100,
      },style:({
        width: _vm.relativeWidth + '%',
        minWidth: _vm.relativeWidth + '%',
        left: _vm.leftPosition,
      })},[_c('span',{staticClass:"slide-container__range-gap__before"}),_c('span',{staticClass:"slide-container__range-gap__after"})])]),_c('div',{ref:"packshot",staticClass:"packshot-container",class:{ _preview: _vm.packshot, _disabled: _vm.isLoadingPackshot },style:({ width: _vm.packshot ? _vm.getPackshotPercentDuration() + '%' : '60px' }),on:{"click":_vm.openEndCardLibraryWindow}},[(_vm.packshot && _vm.packshotType === 'video')?_c('div',{staticStyle:{"height":"90%"}},[_c('canvas',{directives:[{name:"show",rawName:"v-show",value:(_vm.packshot && !_vm.packshotThumbs),expression:"packshot && !packshotThumbs"}],attrs:{"id":"canvasPackshot","width":"288","height":"50"}}),_vm._l((_vm.packshotThumbs),function(thumbSource){return _c('img',{key:thumbSource,style:({
          width: 'calc(100% / ' + _vm.packshotThumbs.length + ')',
          height: '100%',
          position: 'relative',
          objectFit: 'cover',
        }),attrs:{"src":_vm.$baseURL + thumbSource}})})],2):_vm._e(),(_vm.packshot && _vm.packshotType === 'template-default')?_c('div',{staticClass:"packshot-container__thumbs"},[_c('div',{style:({
          width: 'calc(100% / ' + 3 + ')',
        })},[_c('BaseAnimation',{ref:"thumbAnimation1",style:({
            height: 'auto',
            position: 'relative',
            objectFit: 'cover',
            pointerEvents: 'none',
            transform: 'translate(0, -50%)',
            top: '50%',
          }),attrs:{"json":_vm.packshot.json,"autoplay":false,"paused":true}})],1),_c('div',{style:({
          width: 'calc(100% / ' + 3 + ')',
        })},[_c('BaseAnimation',{ref:"thumbAnimation2",style:({
            height: 'auto',
            position: 'relative',
            objectFit: 'cover',
            pointerEvents: 'none',
            transform: 'translate(0, -50%)',
            top: '50%',
          }),attrs:{"json":_vm.packshot.json,"autoplay":false,"startFrame":_vm.packshotDuration * 500,"paused":true}})],1),_c('div',{style:({
          width: 'calc(100% / ' + 3 + ')',
        })},[_c('BaseAnimation',{ref:"thumbAnimation3",style:({
            height: 'auto',
            position: 'relative',
            objectFit: 'cover',
            pointerEvents: 'none',
            transform: 'translate(0, -50%)',
            top: '50%',
          }),attrs:{"json":_vm.packshot.json,"autoplay":false,"paused":true,"startFrame":_vm.packshotDuration * 999}})],1)]):_vm._e(),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.packshot),expression:"packshot"}],staticClass:"packshot-container__after",on:{"click":function($event){$event.stopPropagation();return _vm.trashPackshot($event)}}}),(!_vm.packshot)?_c('div',{staticClass:"packshot-container__button",on:{"click":_vm.addPackshot}},[(_vm.isLoadingPackshot)?_c('div',{staticClass:"circle-loader"}):_vm._e(),(!_vm.isLoadingPackshot)?_c('div',{staticClass:"icon"}):_vm._e()]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }